import React from "react";
import PropTypes from "prop-types";
import NewsletterArea from "../containers/global/newsletter";
import PageBanner from "../containers/global/page-banner";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import Layout from "../layouts/index";
import NewsDetailsContainer from "../containers/news/news-details";
// import BlogData from "../data/blog.json";
// import BlogData from "../data/harsh-blog.json";
// import BlogData from "../data/adnan-blog.json";
// import BlogData from "../data/adnan-news.json";
// import BlogData from "../data/nov16-june19_news.json";
// import BlogData from "../data/harsh-blog2.json";
import NewsData from "../data/news.json";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

const NewsDetailsPage = ({
    match: {
        params: { id },
    },
}) => {
    const newsId = id; //parseInt(id, 10);
    const data = NewsData.filter((newsItem) => newsItem.id === newsId);

    return (
        <React.Fragment>
            <Layout>
                <SEO
                    title={
                        data[0]["title"] +
                        " News | NeoGrowth - Lending simplified. Growth amplified."
                    }
                />
                <div className="wrapper">
                    <Header />
                    {/* <PageBanner
                        title="Blog Details"
                        excerpt="Pleasure rationally encounter consequences <br />
                        are extremely painful great oppurtunity"
                        image="/images/blog/banner.png"
                    /> */}
                    <br></br>
                    <br></br>
                    <NewsDetailsContainer data={data[0]} />
                    {/* <NewsletterArea /> */}
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    );
};

NewsDetailsPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
};

export default NewsDetailsPage;
